/** Events from `PaymentSplitterProtocolFee` for dashboard activity (deposits + claims). */
export const splitterHistoryEventsAbi = [
  {
    type: 'event',
    name: 'PaymentReceived',
    inputs: [
      { name: 'from', type: 'address', indexed: false },
      { name: 'amount', type: 'uint256', indexed: false },
    ],
  },
  {
    type: 'event',
    name: 'PaymentReleased',
    inputs: [
      { name: 'to', type: 'address', indexed: false },
      { name: 'amount', type: 'uint256', indexed: false },
    ],
  },
  {
    type: 'event',
    name: 'ERC20PaymentReleased',
    inputs: [
      { name: 'token', type: 'address', indexed: true },
      { name: 'to', type: 'address', indexed: false },
      { name: 'amount', type: 'uint256', indexed: false },
    ],
  },
] as const;
